import React from "react"
import { Text, VStack, StackProps } from "@chakra-ui/react"

import { useDiscounts } from "@app/hooks/useDiscounts"
import { useSanityColour } from "@app/hooks/useSanity"

type Props = StackProps & {
  lineHeight?: string | number
  tags: string[]
  size?: string
  forceColor?: string
}

const Discount: React.FC<Props> = ({ tags, size, lineHeight, forceColor, ...rest }) => {
  const { getDiscountsFromTags } = useDiscounts()
  const discounts = getDiscountsFromTags(tags)

  return discounts.length ? (
    <VStack alignItems="flex-start" mb={2.5} {...rest}>
      {discounts?.map(
        (discount: GatsbyTypes.SanitySettingDiscounts, idx: number) =>
          discount.enabled && (
            <DiscountText
              key={`${discount.id}-${idx}`}
              discount={discount}
              size={size || ""}
              lineHeight={lineHeight || ""}
              forceColor={forceColor}
            />
          )
      )}
    </VStack>
  ) : null
}

const DiscountText: React.FC<{
  discount: GatsbyTypes.SanitySettingDiscounts
  size?: string
  lineHeight?: string
  forceColor?: string
}> = ({ discount, size, lineHeight, forceColor }) => {
  const { colour } = useSanityColour({ themeColourText: discount?.themeColourText }, { colour: discount?.themeColourText?.custom?.hex })

  return (
    <Text size={size} color={forceColor || colour} lineHeight={lineHeight}>
      {discount.title}
    </Text>
  )
}

export default React.memo(Discount)
